export const CREDIT_VALUES = ["0.5", "1", "1.5", "2"];

export const EMPTY_COMP_OFF_FORM = {
  enabled: false,
  holidays: true,
  weeklyOffs: true,
  generation_method: "automatic",
  min_hours_mode: "full_shift",
  custom_hours: "",
  credit_value: "1",
  max_balance: "5",
  expiry_mode: "after_days",
  expiry_days: "90",
  custom_expiry_date: "",
  approval_required: false,
  reminder_days: "7",
};

export function applicableFromChecks(holidays, weeklyOffs) {
  if (holidays && weeklyOffs) return "both";
  if (holidays) return "holidays";
  if (weeklyOffs) return "weekly_offs";
  return "";
}

export function checksFromApplicable(value) {
  if (value === "holidays") return { holidays: true, weeklyOffs: false };
  if (value === "weekly_offs") return { holidays: false, weeklyOffs: true };
  return { holidays: true, weeklyOffs: true };
}

function tidyNumber(value, fallback) {
  if (value == null || value === "") return fallback;
  return String(value).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
}

export function formFromSettings(data) {
  const checks = checksFromApplicable(data?.applicable_days || "both");
  return {
    enabled: Boolean(data?.enabled),
    ...checks,
    generation_method: data?.generation_method || "automatic",
    min_hours_mode: data?.min_hours_mode || "full_shift",
    custom_hours: tidyNumber(data?.custom_hours, ""),
    credit_value: tidyNumber(data?.credit_value, "1"),
    max_balance: tidyNumber(data?.max_balance, "5"),
    expiry_mode: data?.expiry_mode || "after_days",
    expiry_days: tidyNumber(data?.expiry_days, "90"),
    custom_expiry_date: data?.custom_expiry_date || "",
    approval_required: Boolean(data?.approval_required),
    reminder_days: tidyNumber(data?.reminder_days, "7"),
  };
}

export function payloadFromForm(form) {
  return {
    enabled: Boolean(form.enabled),
    applicable_days: applicableFromChecks(form.holidays, form.weeklyOffs),
    generation_method: form.generation_method,
    min_hours_mode: form.min_hours_mode,
    custom_hours: form.min_hours_mode === "custom" && form.custom_hours !== "" ? Number(form.custom_hours) : null,
    credit_value: Number(form.credit_value),
    max_balance: Number(form.max_balance),
    expiry_mode: form.expiry_mode,
    expiry_days: form.expiry_mode === "after_days" ? Number(form.expiry_days) : null,
    custom_expiry_date: form.expiry_mode === "custom_date" ? form.custom_expiry_date || null : null,
    approval_required: Boolean(form.approval_required),
    reminder_days: Number(form.reminder_days),
  };
}

export function validateCompOffForm(form) {
  const errors = {};
  if (!form.holidays && !form.weeklyOffs) {
    errors.applicable_days = "Select Holidays, Weekly Offs, or both.";
  }
  if (!["automatic", "manual"].includes(form.generation_method)) {
    errors.generation_method = "Choose Automatic or Manual.";
  }
  if (form.min_hours_mode === "custom") {
    const hours = Number(form.custom_hours);
    if (!hours || hours < 0.5 || hours > 24) {
      errors.custom_hours = "Enter custom hours between 0.5 and 24.";
    }
  }
  if (!CREDIT_VALUES.includes(String(form.credit_value))) {
    errors.credit_value = "Choose 0.5, 1, 1.5, or 2 days.";
  }
  const max = Number(form.max_balance);
  const credit = Number(form.credit_value);
  if (!max || max < credit || max > 365) {
    errors.max_balance = "Maximum balance must be at least the credit value and no more than 365 days.";
  }
  if (form.expiry_mode === "after_days") {
    const days = Number(form.expiry_days);
    if (!days || days < 1 || days > 3650) {
      errors.expiry_days = "Enter expiry days between 1 and 3650.";
    }
  }
  if (form.expiry_mode === "custom_date" && !form.custom_expiry_date) {
    errors.custom_expiry_date = "Choose a custom expiry date.";
  }
  const reminder = Number(form.reminder_days);
  if (Number.isNaN(reminder) || reminder < 0 || reminder > 90) {
    errors.reminder_days = "Reminder days must be between 0 and 90.";
  }
  return errors;
}

export function creditLabel(value) {
  const n = Number(value);
  if (n === 1) return "1 Day";
  return `${value} Days`;
}
